import { useMutation, useQueryClient } from '@tanstack/react-query';
import { adminFetch } from '@/lib/apiClient';
import { throwFromResponse } from '../lib/apiErrorMessage';
import { userDetailQueryKey } from './useUserDetailQuery';

export const useUserUnlockMutation = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (userId: string) => {
      const res = await adminFetch(`/api/admin/v1/users/${userId}/unlock`, {
        method: 'POST',
      });
      if (!res.ok) await throwFromResponse(res, '계정 잠금 해제에 실패했습니다.');
    },
    onSuccess: (_data, userId) => {
      void qc.invalidateQueries({ queryKey: ['admin', 'users'] });
      void qc.invalidateQueries({ queryKey: userDetailQueryKey(userId) });
    },
  });
};
